'use client';

import { useTranslations } from 'next-intl';
import { VStack } from '@terra/ui-styled-system';
import { Skeleton } from '../../../components/skeleton';
import { StepperV2 } from '../../../components/stepper-v2';
import { HeadingItem } from '../../../components/typography';
import {
  resolveSensorConnectionProgress,
  type InternalNetworkSensorConnectionState,
} from './internal-connection.model';

export type InternalNetworkSensorConnectionStepsProps =
  InternalNetworkSensorConnectionState & {
    isLoading?: boolean;
  };

export function InternalNetworkSensorConnectionSteps({
  isLoading,
  ...state
}: InternalNetworkSensorConnectionStepsProps) {
  const t = useTranslations(
    'designSystem.networkSettings.internalConnection.sensorConnection',
  );

  if (isLoading) {
    return <Skeleton height="120px" borderRadius="md" />;
  }

  const { completedSteps, currentStepIndex } =
    resolveSensorConnectionProgress(state);

  return (
    <VStack
      alignItems="stretch"
      gap={3}
      borderWidth="1px"
      borderColor="border.neutral.muted"
      borderRadius="md"
      px={4}
      py={3}
    >
      <HeadingItem>{t('title')}</HeadingItem>
      <StepperV2
        steps={[
          { label: t('steps.enrollment') },
          { label: t('steps.online') },
          { label: t('steps.callback') },
          { label: t('steps.verifyReady') },
        ]}
        isCompleted={(stepIndex) => completedSteps[stepIndex] === true}
        isCurrent={(stepIndex) => stepIndex === currentStepIndex}
        isDisabled={() => false}
      />
    </VStack>
  );
}
